var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageServiceContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 36,
    viewBox: "0 0 43 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8379 5.73711C22.784 5.73711 24.361 4.45217 24.361 2.87069C24.361 1.28922 22.784 0.00427246 20.8379 0.00427246C18.8917 0.00427246 17.3201 1.28922 17.3201 2.87069C17.3201 4.45217 18.897 5.73711 20.8379 5.73711Z",
    fill: "#0F336D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8379 7.92029C16.7874 7.92029 15.3581 11.2379 14.9573 14.2118L26.6816 14.1946C26.2438 11.036 24.8146 7.92029 20.8379 7.92029Z",
    fill: "#0F336D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88062 27.0225C7.82676 27.0225 9.40371 25.7376 9.40371 24.1561C9.40371 22.5746 7.82676 21.2897 5.88062 21.2897C3.93447 21.2897 2.36279 22.5746 2.36279 24.1561C2.36279 25.7376 3.93975 27.0225 5.88062 27.0225Z",
    fill: "#0F336D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88062 29.7085C1.83011 29.7085 0.400831 33.0262 0 36L11.7243 35.9828C11.2866 32.8242 9.85729 29.7085 5.88062 29.7085Z",
    fill: "#0F336D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6655 27.5253C38.6117 27.5253 40.1886 26.2404 40.1886 24.6589C40.1886 23.0774 38.6117 21.7925 36.6655 21.7925C34.7194 21.7925 33.1477 23.0774 33.1477 24.6589C33.1477 26.2404 34.7247 27.5253 36.6655 27.5253Z",
    fill: "#0F336D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6655 29.7085C32.615 29.7085 31.1857 33.0262 30.7849 36H42.5092C42.0715 32.8414 40.6422 29.7085 36.6655 29.7085Z",
    fill: "#0F336D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8745 27.723L22.283 23.576V16.2745H19.6407V23.9842L11.8931 27.723L13.238 29.5752L21.3864 25.643L29.5296 29.5752L30.8745 27.723Z",
    fill: "#0F336D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageServiceContact);
export default __webpack_public_path__ + "static/media/manage-service-contact.00dd77bbfeb2ccb3e9c87bea3c877991.svg";
export { ForwardRef as ReactComponent };